import React from 'react'
import DatePicker from 'react-datepicker'
import * as moment from 'moment'

import "react-datepicker/dist/react-datepicker.css";

const DatePickerModule = ({startDate, endDate, setStartDate, setEndDate}: any) => {
    const onChange = (dates: any) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
    };

    const addWeeks = (date: any, nbWeeks: any) => {
      return (moment.utc(date).add(nbWeeks, 'weeks').toDate())
    }

    const subscribeWeeks = (date: any, nbWeeks: any) => {
      return (moment.utc(date).subtract(nbWeeks, 'weeks').toDate())
    }
    
    return (
      <DatePicker
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        minDate={subscribeWeeks(new Date(), 2)}
        maxDate={addWeeks(new Date(), 2)}
        selectsRange
        showWeekNumbers
        inline
      />
    );
  };

export default DatePickerModule;